// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1jb07","imageUploader":"EGiftCard_imageUploader__eqNWl"};